// React/Redux imports
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";

// Redux actions imports
import { fetchModelVersionsForProgram } from "actions/model";

/// Component and Container imports
import ModelVersionsOta from "containers/Devices/Ota/ModelVersionsOta";
import { InlinePreloader } from "ctia-ui";

const CyberDeviceHistory = ({
  modelId,
  requestStatusId,
  fetchModelVersionsForProgram,
  model
}) => {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchModelVersionsForProgram("ota", modelId, requestStatusId).then(() =>
      setLoading(false)
    );
  }, [fetchModelVersionsForProgram, modelId, requestStatusId]);

  if (loading) return <InlinePreloader />;

  if (!model || !model.versions) return <span>No Information</span>;

  return (
    <ModelVersionsOta tableData={model.versions} showLink={true} show={true} />
  );
};

function mapStateToProps({ model }) {
  return { model };
}

export default connect(mapStateToProps, {
  fetchModelVersionsForProgram
})(CyberDeviceHistory);
